import { z } from "zod";

/** Shared metadata for an AI-enabled command. */
interface CopilotCommandMeta<
  TSchema extends z.ZodObject<z.ZodRawShape> = z.ZodObject<z.ZodRawShape>
> {
  /** Unique name, used as both command ID and AI tool name */
  toolName: string;
  /** Human-readable title for command */
  title: string;
  /** Used in both command and AI tool schema */
  description: string;
  /** Zod schema for input, defines both AI tool params and AI command args */
  inputSchema: TSchema;
}

export function defineCopilotCommandMeta<
  TSchema extends z.ZodObject<z.ZodRawShape>
>(meta: CopilotCommandMeta<TSchema>): CopilotCommandMeta<TSchema> {
  return meta;
}

export const COPILOT_COMMANDS = {
  insertHtml: defineCopilotCommandMeta({
    toolName: "insertHtml",
    title: "Insert HTML",
    description: "Insert an HTML/CSS snippet",
    inputSchema: z.object({
      html: z.string().describe("The HTML snippet to be inserted"),
    }),
  }),
} as const;
